var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partnership"},[_c('ul',{staticClass:"clearfix"},_vm._l((_vm.dataList),function(item,index){return _c('li',{key:index,style:('background-image:url('+_vm.imgPath+item.file_path+')'),on:{"click":function($event){return _vm.openUrl(item.link_url)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }